import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-linkedin",
  "use": "icon-linkedin-usage",
  "viewBox": "0 0 25 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 25\" id=\"icon-linkedin\"><path d=\"M19.792,0H5.208A5.209,5.209,0,0,0,0,5.208V19.792A5.209,5.209,0,0,0,5.208,25H19.792A5.208,5.208,0,0,0,25,19.792V5.208A5.208,5.208,0,0,0,19.792,0ZM8.333,19.792H5.208V8.333H8.333ZM6.771,7.013A1.838,1.838,0,1,1,8.594,5.175,1.831,1.831,0,0,1,6.771,7.013ZM20.833,19.792H17.708V13.954c0-3.508-4.167-3.243-4.167,0v5.838H10.417V8.333h3.125v1.839C15,7.478,20.833,7.279,20.833,12.751Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol